export default class EmailInteractionEvent {
    constructor(type, data) {
        this.type = type;
        this.data = data;
    }
}

EmailInteractionEvent.OPEN_MAILBOX = "EmailInteractionEvent.OPEN_MAILBOX";
EmailInteractionEvent.OPEN_CONVERSATION = "EmailInteractionEvent.OPEN_CONVERSATION";
EmailInteractionEvent.OPEN_DRAFT_CHOICE_PICKER = "EmailInteractionEvent.OPEN_DRAFT_CHOICE_PICKER";
EmailInteractionEvent.DRAFT_CHOICE_PICKED = "EmailInteractionEvent.DRAFT_CHOICE_PICKED";
EmailInteractionEvent.CLOSE_DRAFT_CHOICE_PICKER = "EmailInteractionEvent.CLOSE_DRAFT_CHOICE_PICKER";
EmailInteractionEvent.SUBMIT_DRAFT = "EmailInteractionEvent.SUBMIT_DRAFT";